// extracted by mini-css-extract-plugin
module.exports = {"s1898y83":"s1898y83"};